






import { showUnsupportedMessage } from '@/utils/demoUtils';
import Vue from 'vue';
export default Vue.extend({
  methods: {
    onClickDelete(e: Event) {
      showUnsupportedMessage(this.$toast);

      // if (
      //   confirm(
      //     '정말 삭제하시겠습니까?\n하위의 모든 데이터까지 모두 삭제됩니다.',
      //   )
      // ) {
      //   this.$emit('onClickDelete');
      // }

      e.stopPropagation();
    },
  },
});
